import { render, staticRenderFns } from "./CardMinimalTitle.vue?vue&type=template&id=308bafa5&scoped=true&"
import script from "./CardMinimalTitle.vue?vue&type=script&lang=js&"
export * from "./CardMinimalTitle.vue?vue&type=script&lang=js&"
import style0 from "./CardMinimalTitle.vue?vue&type=style&index=0&id=308bafa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bafa5",
  null
  
)

export default component.exports